<template>
  <div class="block block-rounded block-bordered mt-4 mb-3">
    <div class="block-header">
        <p class="block-title mb-0">{{ $t('debtors.debts') }}</p>
    </div>
    <ul class="list-group list-group-flush">
      <template v-for="debtorDebt in debtorDebts" >
        <router-link  :to="'/debt/'+debtorDebt.id" class="list-group-item list-group-item-action" :class="{active: debt.id == debtorDebt.id}" :key="debtorDebt.id">
          {{debtorDebt.number}}
        </router-link>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'debt',
      'debtorDebts',
    ]),
  },
  mounted() {
    this.GET_DEBTOR_DEBTS(this.debt.debtor_iin);
  },
  methods: {
    ...mapActions([
      'GET_DEBTOR_DEBTS',
    ]),
  },
};
</script>
